import { render, staticRenderFns } from "./CurriculumSyllabusNECViewPointRow.vue?vue&type=template&id=01bbeb2c&scoped=true&"
import script from "./CurriculumSyllabusNECViewPointRow.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSyllabusNECViewPointRow.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSyllabusNECViewPointRow.vue?vue&type=style&index=0&id=01bbeb2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bbeb2c",
  null
  
)

export default component.exports